/** The Documents multi-file intake only routes after every accepted upload has a terminal extraction state. */
export interface MultifileBatch {
  demandId: string;
  documentIds: string[];
  uploading: boolean;
}

export function multifileBatchResult(
  batch: MultifileBatch,
  documents: readonly { id: string; extractionStatus?: string }[],
  lineCount: number,
): 'waiting' | 'ready' | 'no-lines' {
  if (batch.uploading || batch.documentIds.length === 0) return 'waiting';
  const byId = new Map(documents.map((document) => [document.id, document]));
  if (
    batch.documentIds.some((id) => {
      const status = byId.get(id)?.extractionStatus;
      return status === undefined || status === 'pending' || status === 'reading';
    })
  )
    return 'waiting';
  return lineCount > 0 ? 'ready' : 'no-lines';
}
